module.exports = function getResource(label, vars = []) {
    let resources = {
        selectYourSamplesText: 'Select your sample(s)',
        getText: 'Get ',
        freeSamplesWithEveryOrderText: ' free sample(s) with every order'
    };

    return resources[label];
};
